import { render, staticRenderFns } from "./cleanAndToDo.vue?vue&type=template&id=7125af6f&scoped=true&"
import script from "./cleanAndToDo.vue?vue&type=script&lang=js&"
export * from "./cleanAndToDo.vue?vue&type=script&lang=js&"
import style0 from "./cleanAndToDo.vue?vue&type=style&index=0&id=7125af6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7125af6f",
  null
  
)

export default component.exports